import * as React from "react";

export interface PreviewRendererProps {
    url: string;
}

/** PDF renderer — uses native browser embed for zero-dependency inline preview. */
export const PdfPreviewRenderer: React.FC<PreviewRendererProps> = ({ url }) => (
    <embed title="File Preview" type="application/pdf" width="100%" height="900px" src={url} />
);
